import React from "react";
import ReactDOM from "react-dom";

function TemplatePreview({ isOpen, onClose, children }) {
  return ReactDOM.createPortal(
    <div
      className={`fixed top-0 left-0 w-full h-screen z-40 flex justify-end transition-opacity duration-300
      ${isOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-[#00000080] backdrop-blur-sm"
        onClick={onClose}
      ></div>

      {/* Drawer */}
      <div
        className={`relative bg-white dark:bg-[#121519] h-full w-[450px] p-4 
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <span className="text-[16px] font-semibold dark:text-white">
            Preview
          </span>

          <button onClick={onClose} className="text-gray-500">
            ✖
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto h-[calc(100%-40px)]">
          {children}
        </div>
      </div>
    </div>,
    document.getElementById("portal-root")
  );
}

export default TemplatePreview;